var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": `${_vm.openedTankRental ? '编辑' : '新增'}储罐借用`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "公司",
      "prop": "company"
    }
  }, [_c('Select', {
    model: {
      value: _vm.formItem.company,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "company", $$v);
      },
      expression: "formItem.company"
    }
  }, _vm._l(_vm.companyList, function (company) {
    return _c('Option', {
      key: company._id,
      attrs: {
        "value": company._id
      }
    }, [_vm._v(_vm._s(company.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "容量/吨",
      "prop": "weight"
    }
  }, [_c('Input', {
    attrs: {
      "type": "number",
      "number": "",
      "placeholder": "输入容量..."
    },
    model: {
      value: _vm.formItem.weight,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "weight", $$v);
      },
      expression: "formItem.weight"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "数量/个",
      "prop": "quantity"
    }
  }, [_c('Input', {
    attrs: {
      "type": "number",
      "number": "",
      "placeholder": "输入数量..."
    },
    model: {
      value: _vm.formItem.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "quantity", $$v);
      },
      expression: "formItem.quantity"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "金额/元",
      "prop": "price"
    }
  }, [_c('Input', {
    attrs: {
      "type": "number",
      "number": "",
      "placeholder": "输入金额..."
    },
    model: {
      value: _vm.formItem.price,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "price", $$v);
      },
      expression: "formItem.price"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "借用日期",
      "prop": "rentalTime"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择借用日期"
    },
    model: {
      value: _vm.formItem.rentalTime,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "rentalTime", $$v);
      },
      expression: "formItem.rentalTime"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入备注..."
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }